import React from 'react';
import './AmbientBackground.css';

const AmbientBackground = () => {
  return (
    <div className="aurora-bg-container">
      <div className="aurora-shape aurora-green-blob"></div>
      <div className="aurora-shape aurora-teal-square"></div>
      <div className="aurora-shape aurora-purple-blob"></div>
      <div className="aurora-shape aurora-purple-square"></div>
    </div>
  );
};

export default AmbientBackground;